const stateKeys = {}

const initialState = {
  transferInfo: {
    newOwnerKnown: true,
    newOwnerEmail: null,
    newOwnerContinueContract: false,
    canContact: false
  },
  temporaryInfo: {
    newOwnerEmail: null,
    canContact: false
  },
  installationHandoverCode: null
}

export const state = () => JSON.parse(JSON.stringify(initialState))

export const mutations = {
  clearStorage(state) {
    for (const prop in initialState) {
      state[prop] = JSON.parse(JSON.stringify(initialState))[prop]
    }
  },
  setTransferInfo(state, value) {
    for (const key in value) {
      if (state.transferInfo[key] !== value[key]) {
        state.transferInfo[key] = value[key]
      }
    }
  },

  setTemporaryInfo(state, value) {
    for (const key in value) {
      if (state.transferInfo[key] !== value[key]) {
        state.temporaryInfo[key] = value[key]
      }
    }
  },

  setInstallationHandoverCode(state, value) {
    state.installationHandoverCode = value
  }
}

export const actions = {
  clearStorage({ commit }) {
    for (const prop in stateKeys) {
      this.$storage.removeUniversal(stateKeys[prop])
    }
    commit('clearStorage')
  }
}
